import { Card, CircularProgress, Grid, Typography } from '@mui/material'

import loginWaves from '../../images/login-waves.png'
import meshifyCentralLogo from '../../images/meshify-central-logo.svg'
import useSharedStyles from '../../utils/shared.styles'
import LoginFooter from '../login-footer'

import useStyles from './index.styles'

const LoggingOut = () => {
  const classes = useStyles
  const sharedClasses = useSharedStyles

  return (
    <>
      <img src={loginWaves} alt="" style={classes.loginWaves} />
      <Grid container={true} sx={[sharedClasses.centerContent, classes.loginContainer]}>
        <Grid>
          <Card sx={classes.loginCard}>
            <Grid container={true} sx={[sharedClasses.centerContentHorizontal, { gap: '24px' }]}>
              <Typography variant="h4">See you later</Typography>
              <Typography variant="body1">We are securely logging you out</Typography>
              <Grid container={true} sx={[sharedClasses.centerContentHorizontal, sharedClasses.fullWidth]}>
                <CircularProgress size={32} />
              </Grid>
              <Grid container={true} sx={[sharedClasses.centerContentHorizontal, sharedClasses.fullWidth]}>
                <img src={meshifyCentralLogo} alt="logo" style={classes.redirectLogo} aria-label="Logo" />
              </Grid>
            </Grid>
          </Card>
        </Grid>

        <LoginFooter />
      </Grid>
    </>
  )
}

export default LoggingOut
